<template>
  <v-app>
    <v-navigation-drawer app clipped v-model="drawer">
      <v-list dense class="pt-0">
        <v-list-tile
          v-for="item in navItems"
          :key="item.name"
          :to="item.to"
          :active-class="item.isActive ? 'primary--text' : ''"
        >
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.name }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-list dense class="pt-0" v-if="isApiEditor">
        <v-subheader>
          Management
        </v-subheader>

        <v-list-tile
          v-for="item in managementItems"
          :key="item.name"
          :to="item.to"
          :active-class="item.isActive ? 'primary--text' : ''"
        >
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.name }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
    </v-navigation-drawer>
    <v-toolbar app clipped-left clipped-right fixed dense flat class="cactus-primary--toolbar">
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>
        <v-icon class="green--text">bubble_chart</v-icon>
        Cactus LIMS
      </v-toolbar-title>
      <!-- <v-breadcrumbs :items="crumbs" divider=">"></v-breadcrumbs> -->
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <AppWhoami></AppWhoami>
      </v-toolbar-items>
    </v-toolbar>
    <v-content>
      <v-container fluid class="pa-0">
        <router-view v-if="user"></router-view>
      </v-container>
    </v-content>
    <AppApiNotification></AppApiNotification>
  </v-app>
</template>

<script>
import { buildNavRoute } from '@/utils/route.js'
import AppWhoami from '@/components/app/app-whoami'
import AppApiNotification from '@/components/app/app--api-notification.vue'
import {mapState} from 'vuex'
export default {
  components: {
    AppWhoami,
    AppApiNotification
  },
  data () {
    return {
      drawer: true
    }
  },
  computed: {
    ...mapState(['user']),
    isApiEditor () {
      return this.user && this.user.role === 'api_dev'
    },
    managementItems () {
      return this.$router.options.routes[0].children
        .filter(cr => cr.meta.nav && (cr.meta.nav.managementRoute))
        .map((cr) => {
          return buildNavRoute(cr, this.$route)
        })
    },
    navItems () {
      // [0] because everything is nested under app-base default route
      return this.$router.options.routes[0].children
        .filter(cr => cr.meta.nav && (!cr.meta.nav.managementRoute))
        .map((cr) => {
          return buildNavRoute(cr, this.$route)
        })
    },
    crumbs () {
      let pathArray = this.$route.path.split('/')
      pathArray.shift()
      let breadcrumbs = pathArray.reduce((breadcrumbArray, path, idx) => {
        let idxAhead = idx + 1
        const disabled = this.$route.path === this.$route.matched[idxAhead].path
        // if (this.$route.matched[idxAhead].meta.childDefault) {
        //   idxAhead = idxAhead + 1
        // }
        breadcrumbArray.push({
          to: { 'path': this.$route.matched[idxAhead].path },
          disabled: disabled,
          activeClass: disabled ? 'v-breadcrumbs__item--disabled' : '',
          text: this.$route.matched[idxAhead].meta.breadCrumb || path
        })
        return breadcrumbArray
      }, [])
      return breadcrumbs
    }
  }
}
</script>

<style>

</style>
